exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mark-disabled[data-v-197b3475]{opacity:.4!important}.action-button-component[data-v-197b3475]:hover{opacity:.7!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-197b3475&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/buttons/ActionButtonComponent.vue
// module id = 852
// module chunks = 2